import {Validator} from "@/lib/forms/validators/Validator";

export class EmptyValidator<T> extends Validator<T> {
    public validate(value: T) {
        return [];
    }
}
